import { CdmProgrammeAvailability } from "../CdmProgrammeAvailability/CdmProgrammeAvailability";
import style from "./CdmSidebar.module.css";
import { Item } from "./Item";

export const CdmSidebar = ({
  cdmList,
  ppList,
  ocfList,
  activeItemId,
  setActiveItemId,
  allowedActions,
  deniedActions,
  onStartReview,
}) => {
  const hasReviews =
    cdmList?.length > 0 || ppList?.length > 0 || ocfList?.length > 0;
  // A patient with no reviews yet still has an availability decision worth
  // showing, so the sidebar is only dropped when there is nothing at all.
  const hasAvailability =
    allowedActions?.length > 0 || deniedActions?.length > 0;

  if (!hasReviews && !hasAvailability) {
    return null;
  }

  return (
    <aside className={style.cdmSidebar}>
      <Item
        items={ocfList}
        name="Opportunistic Case Finding"
        activeItemId={activeItemId}
        setActiveItemId={setActiveItemId}
      />
      <Item
        items={ppList}
        name="Prevention Programme"
        activeItemId={activeItemId}
        setActiveItemId={setActiveItemId}
      />
      <Item
        items={cdmList}
        name="Chronic Disease Management"
        activeItemId={activeItemId}
        setActiveItemId={setActiveItemId}
      />
      <CdmProgrammeAvailability
        allowedActions={allowedActions}
        deniedActions={deniedActions}
        onStartReview={onStartReview}
      />
    </aside>
  );
};
